import React from 'react'
import { useTranslation } from 'react-i18next'

interface QuestionToolbarProps {
  questionId: string
  questionType: string
  makeEditable: boolean
  showCheckbox?: boolean
  isQuestionBank?: boolean
  isQuestionBankMultiEdit?: boolean
  enableDrag?: boolean
  hideAddLogic?: boolean
  selectedNodes?: string[]
  onEdit: (e: React.MouseEvent) => void
  onDelete: (questionId: string) => void
  onLogicClick?: (e: React.MouseEvent) => void
  onCheckboxChange?: (
    e: React.ChangeEvent<HTMLInputElement>,
    id: string,
  ) => void
}

const QuestionToolbar: React.FC<QuestionToolbarProps> = ({
  questionId,
  questionType,
  makeEditable,
  showCheckbox = false,
  isQuestionBank = false,
  isQuestionBankMultiEdit = false,
  enableDrag = false,
  hideAddLogic = false,
  selectedNodes = [],
  onEdit,
  onDelete,
  onLogicClick,
  onCheckboxChange,
}) => {
  const { t } = useTranslation()

  return (
    <>
      {!isQuestionBank && enableDrag && <span className="drag-handle">::</span>}
      <div className="toolbar-actions tolbar-left-vertical">
        {(!isQuestionBank || isQuestionBankMultiEdit) && showCheckbox && (
          <div className="py-1">
            <input
              type="checkbox"
              className="m-0"
              onChange={e => onCheckboxChange?.(e, questionId)}
              checked={selectedNodes.indexOf(questionId) >= 0}
            />
          </div>
        )}
        {!makeEditable && (
          <button className="toolbar-btn" title={t('Edit')} onClick={onEdit}>
            <i className="icon-edit" />
          </button>
        )}

        {questionType === 'radio' &&
          !isQuestionBank &&
          !isQuestionBankMultiEdit &&
          !hideAddLogic &&
          onLogicClick && (
            <button
              onClick={onLogicClick}
              className="toolbar-btn"
              title={t('Add logic/branch')}
            >
              <i className="icon-branch" />
            </button>
          )}

        <button
          onClick={e => {
            e.stopPropagation()
            onDelete(questionId)
          }}
          className="toolbar-btn delete-toolbar-btn"
          title={t('Delete')}
        >
          <i className="icon-delete" />
        </button>
      </div>
    </>
  )
}

export default QuestionToolbar
